import React, { useState, useEffect } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import { useDispatch } from "react-redux";
import LoadingIndicator from "../general/loadingIndicator/LoadingIndicator";
import { retrieveSessionFrontend } from '../../actions/sessionFrontend'
import serviceRest from '../../services/serviceRest'

const ProtectedRouteFrontend = ({ institution, component: Component, user, ...rest }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [sessionChecked, setSessionChecked] = useState(false);
    const [authOk, setAuthOk] = useState(false);

    useEffect(() => {
        let promise = dispatch(retrieveSessionFrontend());
        promise.then((response) => {
            if (response.data.infos.connected) {
                setAuthOk(true);
            } else {
                setAuthOk(false);
            }
            setSessionChecked(true);
        });
    }, [history, dispatch, history.location.pathname]);

    return (
        sessionChecked ?
            <Route {...rest} render={
                props => {
                    if (authOk) {
                        return <Component {...rest} {...props} />
                    } else {
                        var param = {
                            lastPath: props.location.pathname,
                        }
                        serviceRest.post('/react/user/saveLastProtectedPath', param).then((response) => {
                            //nothing
                        }, (error) => {
                            console.log(error);
                        });

                        return <Redirect to={
                            {
                                pathname: '/frontend/connexion/'+institution,
                                state: {
                                    from: props.location
                                }
                            }
                        } />
                    }
                }
            } />
            :
            <LoadingIndicator open={!sessionChecked} />
    )



}

export default ProtectedRouteFrontend;